import React from 'react';

const SuccessCheckIcon = () => (
  <svg
    className='internet-identity-success-popup__icon'
    width='88'
    height='88'
    viewBox='0 0 88 88'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <circle cx='44' cy='44' r='42' stroke='#000' strokeWidth='3' fill='none' />
    <path
      d='M26 45.5L38.5 58L62 32'
      stroke='#9631FF'
      strokeWidth='6'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    />
  </svg>
);

export default SuccessCheckIcon;
